import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebaseConfig";
import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaClock,
  FaNewspaper,
  FaTools,
  FaMapMarkedAlt,
} from "react-icons/fa";

const FooterPage = () => {
  const { pageId } = useParams();

  const [page, setPage] = useState(null);
const [contactInfo, setContactInfo] = useState(null);
const [loading, setLoading] = useState(true);

useEffect(() => {
 const loadPage = async () => {
  setLoading(true);
  setPage(null);
  setContactInfo(null);

  try {
    const snap = await getDoc(
      doc(db, "footer_links", pageId)
    );

    if (snap.exists()) {
      setPage(snap.data());
    }

    if (pageId === "contact") {
      const contactSnap = await getDoc(
        doc(db, "footer_contact", "main")
      );

      if (contactSnap.exists()) {
        setContactInfo(contactSnap.data());
      }
    }
  } catch (error) {
    console.error("Footer page loading error:", error);
  } finally {
    setLoading(false);
  }
};

  loadPage();
}, [pageId]);

if (loading) {
  return (
    <div
      style={{
        minHeight: "50vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontSize: "20px",
        color: "#8b0000",
      }}
    >
      লোড হচ্ছে...
    </div>
  );
}

if (!page && pageId !== "contact") {
  return (
    <div
      style={{
        minHeight: "60vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        padding: "20px",
      }}
    >
      <h2
        style={{
          color: "#8b0000",
          marginBottom: "10px",
        }}
      >
        এই পৃষ্ঠার তথ্য এখনো যোগ করা হয়নি
      </h2>

      <p
        style={{
          color: "#666",
          fontSize: "17px",
        }}
      >
        খুব শীঘ্রই তথ্য প্রকাশ করা হবে।
      </p>
    </div>
  );
}


if (pageId === "contact" && contactInfo) {
  return (
    <div
      style={{
        maxWidth: "1100px",
        margin: "40px auto",
        padding: "0 15px",
      }}
    >
      <h1
        style={{
          fontSize: "30px",
          fontWeight: "700",
          borderBottom: "3px solid #8b0000",
          paddingBottom: "12px",
          marginBottom: "12px",
        }}
      >
        যোগাযোগ
      </h1>

      <p
        style={{
          color: "#666",
          marginBottom: "30px",
          fontSize: "17px",
        }}
      >
        সংবাদ, মতামত বা যেকোনো প্রয়োজনে আমাদের সঙ্গে যোগাযোগ করুন।
      </p>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
          gap: "25px",
        }}
      >
        {/* প্রধান কার্যালয় */}
        <div
          style={{
            border: "1px solid #e5e5e5",
            borderRadius: "10px",
            padding: "25px",
            background: "#fafafa",
          }}
        >
         <h3 style={{ color: "#8b0000", marginTop: 0, display: "flex", alignItems: "center", gap: "8px" }}>
  <FaMapMarkerAlt />
  প্রধান কার্যালয়
</h3>

          <p><strong>ঠিকানা</strong><br />{contactInfo.address}</p>
          <p><strong>অফিস</strong><br />{contactInfo.office}</p>
         <p>
  <strong>মোবাইল</strong><br />
  <a href={`tel:${contactInfo.phone}`}>
    {contactInfo.phone}
  </a>
</p>
          <p>
  <strong>ই-মেইল</strong><br />
  <a href={`mailto:${contactInfo.email}`}>
    {contactInfo.email}
  </a>
</p>
        </div>

        {/* তথ্য ও সহায়তা */}
        <div
          style={{
            border: "1px solid #e5e5e5",
            borderRadius: "10px",
            padding: "25px",
            background: "#fafafa",
          }}
        >
         <h3 style={{ color: "#8b0000", marginTop: 0, display: "flex", alignItems: "center", gap: "8px" }}>
  <FaTools />
  তথ্য ও সহায়তা
</h3>

          <p><strong>অফিস সময়</strong><br />{contactInfo.officeHours}</p>

          <p><strong>সংবাদ পাঠান</strong><br />
		  <a href={`mailto:${contactInfo.newsEmail}`}>
		  {contactInfo.newsEmail}
		  </a>
</p>

          <p><strong>কারিগরি সহায়তা</strong><br />
		  <a href={`mailto:${contactInfo.supportEmail}`}>
		  {contactInfo.supportEmail}
</a>
</p>
          <p><strong>সাপোর্ট ফোন</strong><br />
		  <a href={`tel:${contactInfo.supportPhone}`}>
  {contactInfo.supportPhone}
</a>
		  </p>
        </div>
      </div>

      {/* Google Map */}
      <div
        style={{
          marginTop: "35px",
          border: "1px solid #e5e5e5",
          borderRadius: "10px",
          overflow: "hidden",
          background: "#fff",
        }}
      >
     <h3
  style={{
    margin: 0,
    padding: "16px 20px",
    color: "#8b0000",
    borderBottom: "1px solid #eee",
    display: "flex",
    alignItems: "center",
    gap: "8px",
  }}
>
  <FaMapMarkedAlt />
  আমাদের অবস্থান
</h3>

        {contactInfo.map ? (
          <iframe
            src={contactInfo.map}
            title="Google Map"
            width="100%"
            height="380"
            style={{ border: 0 }}
            loading="lazy"
            allowFullScreen
          />
        ) : (
          <div
            style={{
              padding: "40px",
              textAlign: "center",
              color: "#777",
            }}
          >
            Google Map যোগ করা হয়নি।
          </div>
        )}
      </div>

      <div
        style={{
          marginTop: "30px",
          padding: "20px",
          background: "#fafafa",
          borderLeft: "4px solid #8b0000",
          borderRadius: "6px",
          color: "#555",
          lineHeight: "1.8",
        }}
      >
        আপনার সংবাদ, মতামত কিংবা যেকোনো তথ্য আমাদের ই-মেইলে পাঠাতে পারেন।
        আমরা যথাসম্ভব দ্রুত উত্তর দেওয়ার চেষ্টা করি।
      </div>
    </div>
  );
}



  return (
  
    <div
      style={{
        maxWidth: "900px",
        margin: "40px auto",
        padding: "0 15px",
      }}
    >
    <h1
  style={{
    fontSize: "26px",   // বা 26px, যেটা ভালো লাগে
    fontWeight: "700",
    borderBottom: "2px solid #8b0000",
    paddingBottom: "12px",
    marginBottom: "20px",
  }}
>
  {page.title}
</h1>

      <div
  style={{
    fontSize: "18px",
    lineHeight: "1.9",
  }}
  dangerouslySetInnerHTML={{
    __html: page.content,
  }}
/>
     
    </div>
  );
};

export default FooterPage;